export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-56909aa6510b73ad871574038d422a2d.svg";